

































import { snakeCase } from 'lodash'
import { Component, Prop, Ref, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../logic/helpers/DrawerWidthMixin'
import { CustomConnection } from '../../logic/Connections/CustomConnection'
import CustomEditor from '../../logic/Editor/CustomEditor'
import { CustomNode } from '../../logic/Nodes'
import ConnectionSelectedMenu from './components/ConnectionSelectedMenu.vue'
import NodesSelectedMenu from './components/NodesSelectedMenu.vue'
import NonSelectedMenu from './components/NonSelectedMenu.vue'

@Component({
  data() {
    return {
      snakeCase
    }
  },
  components: {
    NodesSelectedMenu,
    NonSelectedMenu,
    ConnectionSelectedMenu,
  }
})
export default class ContextMenu extends DrawerWidthMixin {
  @Prop() editor!: CustomEditor

  @Ref('context-menu') contextMenuContainer!: HTMLDivElement

  isVisible = false

  @Watch('isVisible')
  onIsVisibleChange(state: boolean) {
    if (!state) {
      this.editor.pseudoOutput = null
    }
  }

  position = {
    x: 0,
    y: 0,
  }

  targetNodes: Array<CustomNode> | null = null

  targetConnection: CustomConnection | null = null

  getPosition(): void {
    if (this.windowWidth > 576) {
      this.getDefaultPoints()
    } else {
      this.getMobilePoints()
    }
  }

  getMobilePoints(): void {
    this.$nextTick(() => {
      const contMenu = this.contextMenuContainer
      const { transform, mouse } = this.editor.view.area

      const defaultXPosition = transform.x + mouse.x * transform.k
      const defaultYPosition = transform.y + mouse.y * transform.k

      let x
      const stopLeft = defaultXPosition < contMenu.clientWidth / 2
      const stopRight = window.innerWidth - defaultXPosition < contMenu.clientWidth / 2

      if (stopLeft) {
        x = defaultXPosition + 15
      } else if (stopRight) {
        x = defaultXPosition - contMenu.clientWidth
      } else {
        x = defaultXPosition - contMenu.clientWidth / 2
      }

      const y = window.innerHeight - defaultYPosition > contMenu.clientHeight
        ? defaultYPosition + 15
        : defaultYPosition - contMenu.clientHeight

      this.position = { x, y }
    })
  }

  getDefaultPoints(): void {
    this.$nextTick(() => {
      const contMenu = this.contextMenuContainer
      const { transform, mouse } = this.editor.view.area

      const defaultXPosition = transform.x + mouse.x * transform.k
      const defaultYPosition = transform.y + mouse.y * transform.k

      const x = window.innerWidth - defaultXPosition > contMenu.clientWidth
        ? defaultXPosition + 15
        : defaultXPosition - contMenu.clientWidth

      const y = window.innerHeight - defaultYPosition > contMenu.clientHeight
        ? defaultYPosition + 15
        : defaultYPosition - contMenu.clientHeight

      this.position = { x, y }
    })
  }

  hide(): void {
    this.isVisible = false
  }

  pasteNodes(): void {
    this.editor.pasteNodes()
  }

  created(): void {
    this.editor.on('triggerContextMenu', ({ nodes, connection, show }) => {
      if (show) {
        this.targetNodes = nodes ?? null
        this.targetConnection = connection ?? null

        this.isVisible = true
        this.getPosition()
      } else {
        this.targetNodes = null
        this.targetConnection = null
        this.isVisible = false
      }
    })
  }
}
